import { useEffect, useState } from 'react'
import { parseQueryString } from '../utils/generic'
import { removeLocaleFromPathname } from '../utils/removeLocaleFromPathname'
import { navigate } from 'gatsby'
import { INFINITE_SCROLL_PAGE_SIZE } from '../utils/constants'

export const usePagination = ({
  items,
  pathname,
  dependencies = [],
  defaultInitialPage = 0,
}) => {
  const [initialPage, setInitialPage] = useState(defaultInitialPage)

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const getInitialPage = () => {
        const { page: queryPage } = parseQueryString(window?.location?.search)
        const defaultPage = queryPage ? Number(queryPage) : 1
        if (defaultPage > items.length / INFINITE_SCROLL_PAGE_SIZE) {
          return Math.floor(items.length / INFINITE_SCROLL_PAGE_SIZE)
        }

        return defaultPage - 1
      }

      setInitialPage(getInitialPage())
    }
  }, [items])

  const [page, setPage] = useState(initialPage)
  const [list, setList] = useState(
    items.slice(initialPage, INFINITE_SCROLL_PAGE_SIZE)
  )

  const isLastPage = (page + 1) * INFINITE_SCROLL_PAGE_SIZE >= items.length

  useEffect(() => {
    const start = initialPage * INFINITE_SCROLL_PAGE_SIZE
    const end = start + INFINITE_SCROLL_PAGE_SIZE
    setList(items.slice(start, end))
    setPage(initialPage)
  }, [items, initialPage, ...dependencies])

  const selectPage = ({ selected: pageNumber }) => {
    const page = pageNumber + 1
    const fixedPathname = removeLocaleFromPathname(pathname)

    if (page === 1) return navigate(fixedPathname)

    navigate(`${fixedPathname}?page=${page}`)
  }

  const nextPage = () => {
    const nextPage = page + 1
    const start = nextPage * INFINITE_SCROLL_PAGE_SIZE
    const end = start + INFINITE_SCROLL_PAGE_SIZE
    const nextItems = items.slice(start, end)
    setList((current) => {
      const filteredItems = [...current, ...nextItems].filter(
        (item, index, self) =>
          index === self.findIndex((g) => g.slug === item.slug)
      )
      return filteredItems
    })
    setPage(nextPage)
  }

  return {
    list,
    isLastPage,
    page,
    selectPage,
    nextPage,
    setInitialPage,
    setPage,
  }
}
